<template>
    <div class="wrapper">
        <page-header/>
        <div class="section">
            <div class="container">
                <h2 class="text-center">訂單列表</h2>
                <div class="row">
                    <div class="col-12">
                        <order-list-item v-for="order in orderList" :item="order" :key="order.order_id" />
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading @infinite="loadMore">
            <div slot="no-more">沒有更多訂單囉</div>
            <div slot="no-results">沒有更多訂單囉</div>
        </infinite-loading>
    </div>
</template>

<script>
    import {ORDER_QUERY} from "@/services/graphql/order";
    import InfiniteLoading from "vue-infinite-loading";
    import OrderListItem from "./OrderListItem";
    import PageHeader from "../partials/PageHeader";
    import Vue from "vue";

    Vue.use(InfiniteLoading, {
        props: {
            distance: 800
        },
        system: {
            throttleLimit: 100
        }
    });

    export default {
        name: "OrderList",
        components: {
            PageHeader,
            OrderListItem,
            InfiniteLoading
        },
        data() {
            return {
                first: 10,
                currentPage: 1,
                orderList: [],
            }
        },
        methods: {
            async loadMore($state) {
                try {
                    const q = await this.$apollo.query({
                        query: ORDER_QUERY,
                        variables: {
                            first: this.first,
                            page: this.currentPage,
                        },
                        fetchPolicy: "network-only"
                    });

                    const orderData = q.data.order.data;

                    this.orderList.push(...orderData);
                    this.currentPage += 1;
                    if (orderData.length === 0) $state.complete();
                    else $state.loaded();
                } catch (err) {
                    console.error(err);
                    $state.complete();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
</style>